import { InjectionKey } from '@vue/composition-api'

export const anchorPrefixProvideKey: InjectionKey<string> = Symbol('GAnchorNameSpace')
